import {useEffect} from "react";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";

const ItemList = ({ items = [], onChange }) => {

    const addItem = () => {
        onChange([...items, ""]);
    };

    const removeItem = (index) => {
        onChange(items.filter((_, i) => i !== index));
    };

    const updateItem = (index, value) => {
        const newItems = [...items];
        newItems[index] = value;
        onChange(newItems);
    };

    useEffect(() => {
        if (items.length === 0) {
            onChange([""]);
        }
    }, []);

    return (
        <>
            <ol className="flex flex-col gap-4">
                {items.map((item, idx) => (
                    <li key={idx} className="flex gap-4 items-end">
                        <div className="flex-1">
                            <InputForm
                              id={`${idx}__item_name`}
                                label="Nome"
                                value={item}
                                onChange={(e) =>
                                    updateItem(idx, e.target.value)
                                }
                            />
                        </div>
                        <Button
                            target="danger"
                            onClick={() => removeItem(idx)}
                        >
                            <FaTrash />
                        </Button>
                    </li>
                ))}
            </ol>

            <div>
                <Button onClick={addItem}>
                    <FaPlus /> Adicionar item
                </Button>
            </div>
        </>
    );
};

export default ItemList
